export interface BusinessNavigationMetrics {
  keyWidth: number;
  keyGap: number;
  moreWidth: number;
  moreGap: number;
}

const DEFAULT_METRICS: BusinessNavigationMetrics = {
  keyWidth: 144,
  keyGap: 7,
  moreWidth: 144,
  moreGap: 5,
};

export function calculateVisibleBusinessKeyCount(
  availableWidth: number,
  itemCount: number,
  metrics: BusinessNavigationMetrics = DEFAULT_METRICS,
) {
  if (itemCount <= 0) return 0;

  const usableWidth = Math.max(0, availableWidth - metrics.moreWidth - metrics.moreGap);
  const capacity = Math.floor((usableWidth + metrics.keyGap) / (metrics.keyWidth + metrics.keyGap));

  return Math.min(itemCount, Math.max(1, capacity));
}
